// extracted by mini-css-extract-plugin
module.exports = {"button":"_3JnmQ","link":"_2tNq0","mobileLink":"_1Ns-1","description":"_3Gbj7","expanded":"_2Rxcj"};